import * as pageTypes from "../page/types";
import { combineReducers } from "redux";
import { availableCategories } from "../../../helpers/categorySchedule";
import { addTaxBreakdownKeyToTaxes } from "../../../helpers/utils";

const categoriesReducer = (state = [], action: any) => {
  switch (action.type) {
    case pageTypes.FETCH_HOME_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_CHECKOUT_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_PAST_ORDERS_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_ORDER_DETAILS_CONFIGURATIONS_SUCCESS:
      const allowStoreClosedOrdering =
        action.payload.data.company.configuration?.allow_order_when_closed ||
        false;
      return availableCategories(
        action.payload.data.menu.categories || [],
        allowStoreClosedOrdering
      );

    default:
      return state;
  }
};

const taxesReducer = (state = [], action: any) => {
  switch (action.type) {
    case pageTypes.FETCH_HOME_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_CHECKOUT_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_ORDER_DETAILS_CONFIGURATIONS_SUCCESS:
      const taxes = action.payload.data.menu.taxes || [];
      const taxBreakDownEnabled = action.payload?.data?.company?.tax_breakdown_enabled ?? false;
      const transformedTaxes = addTaxBreakdownKeyToTaxes(taxes, taxBreakDownEnabled);
      return transformedTaxes;

    default:
      return state;
  }
};

const surchargesReducer = (state = [], action: any) => {
  switch (action.type) {
    case pageTypes.FETCH_HOME_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_CHECKOUT_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_ORDER_DETAILS_CONFIGURATIONS_SUCCESS:
      return action.payload.data.menu.surcharges || [];

    default:
      return state;
  }
};

const taxInclusiveReducer = (state = true, action: any) => {
  switch (action.type) {
    case pageTypes.FETCH_HOME_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_CHECKOUT_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_ORDER_DETAILS_CONFIGURATIONS_SUCCESS:
      return action.payload.data.menu.is_tax_inclusive || false;

    default:
      return state;
  }
};

const outOfStockItemsReducer = (state = [], action: any) => {
  switch (action.type) {
    case pageTypes.FETCH_HOME_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_CHECKOUT_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_ORDER_DETAILS_CONFIGURATIONS_SUCCESS:
      return action.payload.data.out_of_stock_items || [];

    default:
      return state;
  }
};

const reducer = combineReducers({
  categories: categoriesReducer,
  taxes: taxesReducer,
  surcharges: surchargesReducer,
  is_tax_inclusive: taxInclusiveReducer,
  out_of_stock_items: outOfStockItemsReducer,
});

export default reducer;
